import React from "react"
import ReassignCustomerGeneral from "./tabs/ReassignCustomerGeneral"
import ReassignCustomerNotes from "./tabs/ReassignCustomerNotes"
import ErrorHelper from "../Errors/ErrorHelper"

class ReassignCustomerTabContent extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="tab-content">
        {this.props.errors ? ErrorHelper.renderErrors(this.props.errors, ['customer', 'card', 'name_on_card', 'card_validation', 'reservation']) : null}
        <ReassignCustomerGeneral {...this.props} />
        <ReassignCustomerNotes {...this.props} />
      </div>
    )
  }
}

export default ReassignCustomerTabContent
